export default __webpack_public_path__ + "static/media/web-error.36a34000.webm";